import React, { useState, useEffect } from 'react';
import { commerce } from './lib/commerce';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import styled from 'styled-components';
import { Products, Navbar, Cart, Checkout } from './components';

const App = () => {
  const [products, setProducts] = useState([]);
  const [cart, setCart] = useState({});
  const [order, setOrder] = useState({});
  const [errorMessage, setErrorMessage] = useState('');

  const fetchProducts = async () => {
    const res = await commerce.products.list();

    setProducts(res.data);
  };

  const fetchCart = async () => {
    setCart(await commerce.cart.retrieve());
  };
  const handleAddToCart = async (productId, quantity) => {
    const res = await commerce.cart.add(productId, quantity);

    setCart(res.cart);
  };

  const handleUpdateCartQty = async (productId, quantity) => {
    const res = await commerce.cart.update(productId, { quantity });

    setCart(res.cart);
  };

  const handleRemoveFromCart = async (productId) => {
    const res = await commerce.cart.remove(productId);

    setCart(res.cart);
  };

  const handleEmptyCart = async () => {
    const res = await commerce.cart.empty();

    setCart(res.cart);
  };

  const refreshCart = async () => {
    const newCart = await commerce.cart.refresh();

    setCart(newCart);
  };

  const handleCaptureCheckOut = async (checkoutTokenId, newOrder) => {
    try {
      const incomingOrder = await commerce.checkout.capture(
        checkoutTokenId,
        newOrder
      );

      setOrder(incomingOrder);
      refreshCart();
    } catch (error) {
      setErrorMessage(error.data.error.message);
    }
  };

  useEffect(() => {
    fetchProducts();
    fetchCart();
  }, []);

  return (
    <Router>
      <Background>
        <HomeApp>
          <Navbar totalItems={cart.total_items} />
          <Switch>
            <Route exact path='/'>
              <Products products={products} onAddToCart={handleAddToCart} />
            </Route>
            <Route exact path='/cart'>
              <Cart
                cart={cart}
                handleUpdateCartQty={handleUpdateCartQty}
                handleRemoveFromCart={handleRemoveFromCart}
                handleEmptyCart={handleEmptyCart}
              />
            </Route>
            <Route exact path='/checkout'>
              <Checkout
                order={order}
                onCaptureCheckout={handleCaptureCheckOut}
                error={errorMessage}
                cart={cart}
              />
            </Route>
          </Switch>
        </HomeApp>
      </Background>
    </Router>
  );
};

export default App;

const HomeApp = styled.div`
  height: 100%;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  background: rgba(255, 255, 255, 0.4);
  border-radius: 1rem;
`;
const Background = styled.div`
  height: 100%;
  width: 100%;
  padding: 1rem;
  background: rgba(0, 0, 0, 0.7);
`;
